import { t as AitisalSdk } from "../aitisal-sdk-B2mK3RTK.mjs";

//#region restaurant/index.ts
async function updateRestaurant(restaurantUUID, updateRestaurant) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}`, updateRestaurant);
}
async function updateRestaurantLocation(restaurantUUID, updateRestaurantLocation) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/location`, updateRestaurantLocation);
}
async function getRestaurant(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}`);
}
async function getDeliveryAreaPolygon(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/delivery-area/polygon`);
}
async function getRestaurantEventListener(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/listener-token`);
}
async function browseRestaurants() {
	return AitisalSdk.getInstance().get("restaurants");
}
async function getRestaurantDashboard(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/dashboard`);
}
async function updateRestaurantSettings(restaurantUUID, updateRestaurantSettings) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/settings`, updateRestaurantSettings);
}
async function getRestaurantSettings(restaurantUUID, settingGroup) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/settings`, { params: { settingGroup } });
}
async function getBrandByDomain(domain) {
	return AitisalSdk.getInstance().get(`brands/domain`, { params: { domain } });
}
async function getBrandAreas(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/areas`);
}
async function getBranchByArea(brandUUID, restaurantAreaUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/branch/${restaurantAreaUUID}`);
}
async function getNearestBranch(brandUUID, geoCoordinate) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/branch`, { params: geoCoordinate });
}
async function getAllBranches(geoCoordinate) {
	return AitisalSdk.getInstance().get(`brands/branches`, { params: geoCoordinate });
}
async function getBranches(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/branches`);
}
async function browseBranchDeliveryMethods(restaurantUUID, restaurantAreaUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/${restaurantAreaUUID}/delivery-methods`);
}
async function updateBrand(brandUUID, updateBrand) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}`, updateBrand);
}
async function updateBrandingConfig(brandUUID, updateBrandingConfig) {
	return AitisalSdk.getInstance().put(`brands/${brandUUID}/branding-config`, updateBrandingConfig);
}
async function getBrandingConfig(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/branding-config`);
}
async function getLogoPresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/logo/presigned-url`, { params: { ...getImageUploadURLRequest } });
}
async function getBackgroundPresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/background/presigned-url`, { params: { ...getImageUploadURLRequest } });
}
async function getHeroImagePresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/hero/presigned-url`, { params: { ...getImageUploadURLRequest } });
}
async function getFaviconPresignedURL(brandUUID, getImageUploadURLRequest) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/favicon/presigned-url`, { params: { ...getImageUploadURLRequest } });
}
async function createTicker(brandUUID, createTicker) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/tickers`, createTicker);
}
async function deleteTicker(brandUUID, tickerUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/tickers/${tickerUUID}`);
}
async function browseTickers(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/tickers`);
}
async function createRestaurantArea(restaurantUUID, createRestaurantArea) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/areas`, createRestaurantArea);
}
async function getRestaurantArea(restaurantUUID, areaUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/areas/${areaUUID}`);
}
async function getRestaurantAreas(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/areas`);
}
async function updateRestaurantArea(restaurantUUID, areaUUID, updateRestaurantArea) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/areas/${areaUUID}`, updateRestaurantArea);
}
async function deleteRestaurantArea(restaurantUUID, areaUUID) {
	return AitisalSdk.getInstance().delete(`restaurants/${restaurantUUID}/areas/${areaUUID}`);
}
async function browseNewOrders(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/orders/new`);
}
async function browseAcceptedOrders(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/orders/accepted`);
}
async function getVideoPresignedURL(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/videos/presigned-url`);
}
async function createVideo(brandUUID, createVideo) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/videos`, createVideo);
}
async function browseBrandVideos(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/videos`);
}
async function browseAllVideos() {
	return AitisalSdk.getInstance().get(`brands/videos`);
}
async function deleteVideo(brandUUID, videoUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/videos/${videoUUID}`);
}

//#endregion
export { browseAcceptedOrders, browseAllVideos, browseBranchDeliveryMethods, browseBrandVideos, browseNewOrders, browseRestaurants, browseTickers, createRestaurantArea, createTicker, createVideo, deleteRestaurantArea, deleteTicker, deleteVideo, getAllBranches, getBackgroundPresignedURL, getBranchByArea, getBranches, getBrandAreas, getBrandByDomain, getBrandingConfig, getDeliveryAreaPolygon, getFaviconPresignedURL, getHeroImagePresignedURL, getLogoPresignedURL, getNearestBranch, getRestaurant, getRestaurantArea, getRestaurantAreas, getRestaurantDashboard, getRestaurantEventListener, getRestaurantSettings, getVideoPresignedURL, updateBrand, updateBrandingConfig, updateRestaurant, updateRestaurantArea, updateRestaurantLocation, updateRestaurantSettings };
//# sourceMappingURL=index.mjs.map